import axios from "axios";
import React from "react";
import { useState } from "react";
import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { API_URL } from "../../const/api";
import {
  selectCurrency,
  selectId,
  selectToken,
  setNewToken,
} from "../../features/user/userSlice";
import { useDeposit } from "../../hooks/useDeposit";
import { GoBackButton, MainViewContainer, NoMethodSelected } from "./DepositElements";
import FormAstroPay from "./FormAstroPay";
import FormDeposit from "./FormDeposit";
import FormPagoEfectivo from "./FormPagoEfectivo";
import FormPay4Fun from "./FormPay4Fun";
import FormSafetyPay from "./FormSafetyPay";
import FormTotalPago from "./FormTotalPago";
import FormTotalPagoBFC from "./FormTotalPagoBFC";
import FormNuvei from "./FormNuvei";
import FormMonnet from "./FormMonnet";
import FormMonnetTarjeta from "./FormMonnetTarjeta";
import FormMonnetBancos from "./FormMonnetBancos";
import FormMonnetYape from "./FormMonnetYape";
import FormPFtigomoney from "./FormPFtigomoney";
import FormPFyape from "./FormPFyape";
import FormPFqr from "./FormPFqr";
import FormCoinspaid from "./FormCoinspaid";
import ForwardIcon from '@mui/icons-material/Forward';
import { ReactComponent as DepositLogo } from '../../assets/images/logos/deposito-main.svg';
import FormPayRetailers from "./FormPayRetailer";
import { useTranslation } from "react-i18next";
import FormTuPay from "./FormTuPay";
import FormTuPayXAQR from "./FormTuPayXAQR";
import FormSpei from "./FormSpei";
import FormBetterARS from "./FormBetterARS";
import FormPix from "./FormPix";
import FormBoleto from "./FormBoleto";
import FormBinanceOtro from "./FormBinanceOtro";
import FormAlps from "./FormAlps";
import FormDeuna from "./FormDeuna";
import FormTuPayXACC from "./FormTuPayXACC";
import FormTotalPagoBNC from "./FormTotalPagoBNC";
import FormKushkiTransf from "./FormKushkiTransf";
import FormKushkiEfect from "./FormKushkiEfect";
import FormKushkiCard from "./FormKushkiCard";
import FormMiBanco from "./FormMiBanco";
import FormPFqrbisa from "./FormPFqrbisa";
import FormPFqrMercantil from "./FormPFqrMercantil";
import FormAlpsEfectivoChile from "./FormAlpsEfectivoChile";
import FormAlpsTarjetaChile from "./FormAlpsTarjetaChile";
import FormAlpsTransfChile from "./FormAlpsTransfChile";
import FormOxxo from "./FormOxxo";
import FormMonnetGTQCash from "./FormMonnetGTQCash";
import FormMonnetGTQTransf from "./FormMonnetGTQTransf";
import FormTransPYG from "./FormTransPYG";
import FormBDV from "./FormBDV";
import FormMonnetTarjetaEcu from "./FormMonnetTarjetaEcu";
import FormMonnetBancosCH from "./FormMonnetBancosCH";


const MainView = ({ depositMethod, handleExit }) => {
  const [t] = useTranslation("global");
  const id_uo = useSelector(selectId);
  const token = useSelector(selectToken);
  const moneda = useSelector(selectCurrency);
  const [bancos, setBancos] = useState([]);
  const [tipo, setTipo] = useState([]);
  const [pagoEfectivo, setPagoEfectivo] = useState(false);
  const dispatch = useDispatch();

  useEffect(() => {
    const loadData = async () => {
      const body = {
        id_uo,
        token,
        moneda,
      };
      const res = await axios.post(API_URL + "cargarDatosDepositos", body);
      if (res.data.status === 1) {
        dispatch(setNewToken(res.data.token));
        setBancos(res.data.response.bancos);
        setTipo(res.data.response.tipo);
        setPagoEfectivo(res.data.response.pagoEfectivo);
      } else {
        dispatch(setNewToken(res.data.token));
      }
    };
    loadData();
  }, []);

  //HOOKS
  const {
    loading,
    form,
    formAstroPay,
    formPay4Fun,
    formSafetyPay,
    formTotalPago,
    formTotalPagoBFC,
    formPayRetailer,
    formTuPay,
    formTuPayXAQR,
    formTuPayXACC,
    formPagoEfectivo,
    formNuvei,
    formMonnet,
    formMonnetTarjeta,
    formMonnetBancos,
    formMonnetYape,
    formPFtigomoney,
    formPFyape,
    formPFqr,
    formCoinspaid,
    formSpei,
    formBetterArs,
    formPix,
    formBoleto,
    formBinanceOtro,
    formAlps,
    formDeuna,
    formTotalPagoBNC,
    formKuskiTransf,
    formKushkiEfect,
    formKushkiCard,
    formMiBanco,
    formPFqrbisa,
    formPFqrMercantil,
    formAlpsEfectivoChile,
    formAlpsTarjetaChile,
    formAlpsTransfChile,
    formOxxo,
    formMonnetGTQCash,
    formMonnetGTQTransf,
    formTransPYG,
    formBDV,
    formMonnetTarjetaEcu,
    formMonnetBancosCH,
    image,
    zelleAct,
    bancosRetailer,
    loadingBancosRetailer,
    setImage,
    handleChange,
    handleChangeRetailer,
    handleChangeTotalPago,
    handleChangeTotalPagoBFC,
    handleChangeSafetyPay,
    handleChangeAstroPay,
    handleChangeNuvei,
    handleChangePayRetailer,
    handleChangeTuPay,
    handleChangeTuPayXAQR,
    handleChangeTuPayXACC,
    handleChangeMonnet,
    handleChangeMonnetTarjeta,
    handleChangeMonnetBancos,
    handleChangeMonnetYape,
    handleChangePFtigomoney,
    handleChangePFyape,
    handleChangePFqr,
    handleChangeCoinspaid,
    handleChangeSpei,
    handleChangeBetterArs,
    handleChangePix,
    handleChangeBoleto,
    handleChangeBinanceOtro,
    handleChangeAlps,
    handleChangeDeuna,
    handleChangeKuskiTransf,
    handleChangeKushkiEfect,
    handleChangeKushkiCard,
    handleSubmit,
    handleChangePagoEfectivo,
    handleChangeTotalPagoBNC,
    handleChangePFqrbisa,
    handleChangePFqrMercantil,
    handleChangeAlpsEfectivoChile,
    handleChangeAlpsTarjetaChile,
    handleChangeAlpsTransfChile,
    handleChangeOxxo,
    handleChangeMonnetGTQCash,
    handleChangeMonnetGTQTransf,
    handleChangeTransPYG,
    handleChangeMonnetTarjetaEcu,
    handleChangeMonnetBancosCH,
    submitPagoEfectivo,
    submitPay4Fun,
    submitTotalPago,
    submitTotalPagoBFC,
    submitSafetypay,
    submitAstroPay,
    submitNuvei,
    submitPayRetailer,
    submitTuPay,
    submitTuPayXAQR,
    submitTuPayXACC,
    submitMonnet,
    submitMonnetTarjeta,
    submitMonnetBancos,
    submitMonnetYape,
    submitPFtigomoney,
    submitPFyape,
    submitPFqr,
    submitCoinspaid, 
    submitSpei,
    submitBetterArs, 
    submitPix, 
    submitBoleto,
    submitBinanceOtro, 
    submitAlps,
    submitDeuna,
    submitTotalPagoBNC, 
    submitKuskiTransf,
    submitKushkiEfect,
    submitKushkiCard,
    submitPFqrbisa,
    submitPFqrMercantil,
    submitAlpsEfectivoChile,
    submitAlpsTarjetaChile,
    submitAlpsTransfChile,
    submitOxxo,
    submitMonnetGTQCash,
    submitMonnetGTQTransf,
    submitTransPYG,
    submitMonnetTarjetaEcu,
    submitMonnetBancosCH,
    auto
  } = useDeposit();

  return (

    <MainViewContainer>
    {/*<GoBackButton onClick={() => {handleExit()}}>
      <ForwardIcon/> Volver
    </GoBackButton>*/}
      {depositMethod === "deposit" && (
        <FormDeposit
          form={form}
          handleChange={handleChange}
          handleClose={handleExit}
          handleSubmit={handleSubmit}
          loading={loading}
          image={image}
          setImage={setImage}
          tipo={tipo}
          bancos={bancos}
          zelle={zelleAct}
        />
      )}
      {depositMethod === "pagoEfectivo" && (
        <FormPagoEfectivo
          form={formPagoEfectivo}
          handleChange={handleChangePagoEfectivo}
          handleClose={handleExit}
          handleSubmit={submitPagoEfectivo}
          loading={loading}
        />
      )}
      {depositMethod === "pagoEfectivo2" && (
        <FormPagoEfectivo
          form={formPagoEfectivo}
          handleChange={handleChangePagoEfectivo}
          handleClose={handleExit}
          handleSubmit={submitPagoEfectivo}
          loading={loading}
        />
      )}
      {depositMethod === "pay4fun" && (
        <FormPay4Fun
          form={formPay4Fun}
          handleChange={handleChangeRetailer}
          handleClose={handleExit}
          handleSubmit={submitPay4Fun}
          loading={loading}
        />
      )}
      {depositMethod === "pay4fun2" && (
        <FormPay4Fun
          form={formPay4Fun}
          handleChange={handleChangeRetailer}
          handleClose={handleExit}
          handleSubmit={submitPay4Fun}
          loading={loading}
        />
      )}
      {depositMethod === "safetyPay" && (
        <FormSafetyPay
          form={formSafetyPay}
          handleChange={handleChangeSafetyPay}
          handleClose={handleExit}
          handleSubmit={submitSafetypay}
          loading={loading}
        />
      )}
      {depositMethod === "totalPago" && (
        <FormTotalPago
          form={formTotalPago}
          handleChange={handleChangeTotalPago}
          handleClose={handleExit}
          handleSubmit={submitTotalPago}
          loading={loading}
        />
      )}
      {depositMethod === "totalPagoBFC" && (
        <FormTotalPagoBFC
          form={formTotalPagoBFC}
          handleChange={handleChangeTotalPagoBFC}
          handleClose={handleExit}
          handleSubmit={submitTotalPagoBFC}
          loading={loading}
        />
      )}
      {depositMethod === "astropay" && (
        <FormAstroPay
          form={formAstroPay}
          handleChange={handleChangeAstroPay}
          handleClose={handleExit}
          handleSubmit={submitAstroPay}
          loading={loading}
        />
      )}
      {depositMethod === "nuvei" && (
        <FormNuvei
          form={formNuvei}
          handleChange={handleChangeNuvei}
          handleClose={handleExit}
          handleSubmit={submitNuvei}
          loading={loading}
        />
      )}
      {depositMethod === "nuvei2" && (
        <FormNuvei
          form={formNuvei}
          handleChange={handleChangeNuvei}
          handleClose={handleExit}
          handleSubmit={submitNuvei}
          loading={loading}
        />
      )}
      {depositMethod === "nuvei3" && (
        <FormNuvei
          form={formNuvei}
          handleChange={handleChangeNuvei}
          handleClose={handleExit}
          handleSubmit={submitNuvei}
          loading={loading}
        />
      )}

      {depositMethod === "tupayXACC" && (
        <FormTuPayXACC
          form={formTuPayXACC}
          handleChange={handleChangeTuPayXACC}
          handleClose={handleExit}
          handleSubmit={submitTuPayXACC}
          loading={loading}
        />
      )}
      {depositMethod === "tupay2" && (
        <FormTuPay
          form={formTuPay}
          handleChange={handleChangeTuPay}
          handleClose={handleExit}
          handleSubmit={submitTuPay}
          loading={loading}
        />
      )}
      {depositMethod === "tupayXAQR" && (
        <FormTuPayXAQR
          form={formTuPayXAQR}
          handleChange={handleChangeTuPayXAQR}
          handleClose={handleExit}
          handleSubmit={submitTuPayXAQR}
          loading={loading}
        />
      )}

      {depositMethod === "payretailer" && (
        <FormPayRetailers
          form={formPayRetailer}
          handleChange={handleChangePayRetailer}
          handleClose={handleExit}
          handleSubmit={submitPayRetailer}
          loading={loading}
          bancos={bancosRetailer}
          loadingBancos={loadingBancosRetailer}
        />
      )}
      {depositMethod === "monnet" && (
        <FormMonnet
          form={formMonnet}
          handleChange={handleChangeMonnet}
          handleClose={handleExit}
          handleSubmit={submitMonnet}
          loading={loading}
        />
      )}
      {depositMethod === "monnetTarjeta" && (
        <FormMonnetTarjeta
          form={formMonnetTarjeta}
          handleChange={handleChangeMonnetTarjeta}
          handleClose={handleExit}
          handleSubmit={submitMonnetTarjeta}
          loading={loading}
        />
      )}
      {depositMethod === "monnetBancos" && (
        <FormMonnetBancos
          form={formMonnetBancos}
          handleChange={handleChangeMonnetBancos}
          handleClose={handleExit}
          handleSubmit={submitMonnetBancos}
          loading={loading}
        />
      )}
      {depositMethod === "monnetYape" && (
        <FormMonnetYape
          form={formMonnetYape}
          handleChange={handleChangeMonnetYape}
          handleClose={handleExit}
          handleSubmit={submitMonnetYape}
          loading={loading}
        />
      )}
      {depositMethod === "PFtigomoney" && (
        <FormPFtigomoney
          form={formPFtigomoney}
          handleChange={handleChangePFtigomoney}
          handleClose={handleExit}
          handleSubmit={submitPFtigomoney}
          auto={auto}
          loading={loading}
        />
      )}
      {depositMethod === "PFyape" && (
        <FormPFyape
          form={formPFyape}
          handleChange={handleChangePFyape}
          handleClose={handleExit}
          handleSubmit={submitPFyape}
          auto={auto}
          loading={loading}
        />
      )}
      {depositMethod === "PFqr" && (
        <FormPFqr
          form={formPFqr}
          handleChange={handleChangePFqr}
          handleClose={handleExit}
          handleSubmit={submitPFqr}
          auto={auto}
          loading={loading}
        />
      )}
      {depositMethod === "Coinspaid" && (
        <FormCoinspaid
          form={formCoinspaid}
          handleChange={handleChangeCoinspaid}
          handleClose={handleExit}
          handleSubmit={submitCoinspaid}
          loading={loading}
        />
      )}
      {depositMethod === "Spei" && (
        <FormSpei
          form={formSpei}
          handleChange={handleChangeSpei}
          handleClose={handleExit}
          handleSubmit={submitSpei}
          loading={loading}
        />
      )}
      {depositMethod === "Betterarg" && (
        <FormBetterARS
          form={formBetterArs}
          handleChange={handleChangeBetterArs}
          handleClose={handleExit}
          handleSubmit={submitBetterArs}
          loading={loading}
        />
      )}
      {depositMethod === "Pix" && (
        <FormPix
          form={formPix}
          handleChange={handleChangePix}
          handleClose={handleExit}
          handleSubmit={submitPix}
          loading={loading}
        />
      )}
      {depositMethod === "Boleto" && (
        <FormBoleto
          form={formBoleto}
          handleChange={handleChangeBoleto}
          handleClose={handleExit}
          handleSubmit={submitBoleto}
          loading={loading}
        />
      )}
      {depositMethod === "BinanceOtro" && (
        <FormBinanceOtro
          form={formBinanceOtro}
          handleChange={handleChangeBinanceOtro}
          handleClose={handleExit}
          handleSubmit={submitBinanceOtro}
          loading={loading}
        />
      )}
      {depositMethod === "Alps" && (
        <FormAlps
          form={formAlps}
          handleChange={handleChangeAlps}
          handleClose={handleExit}
          handleSubmit={submitAlps}
          loading={loading}
        />
      )}
      {depositMethod === "KushkiTransf" && (
        <FormKushkiTransf
          form={formKuskiTransf}
          handleChange={handleChangeKuskiTransf}
          handleClose={handleExit}
          handleSubmit={submitKuskiTransf}
          loading={loading}
        />
      )}
      {depositMethod === "KushkiEfectivo" && (
        <FormKushkiEfect
          form={formKushkiEfect}
          handleChange={handleChangeKushkiEfect}
          handleClose={handleExit}
          handleSubmit={submitKushkiEfect}
          loading={loading}
        />
      )}
      {depositMethod === "KushkiCard" && (
        <FormKushkiCard
        form={formKushkiCard}
        handleChange={handleChangeKushkiCard}
        handleClose={handleExit}
        handleSubmit={submitKushkiCard}
        loading={loading}
      />
      )}

      {depositMethod === "Deuna" && (
        <FormDeuna
          form={formDeuna}
          handleChange={handleChangeDeuna}
          handleClose={handleExit}
          handleSubmit={submitDeuna}
          loading={loading}
        />
      )}
      {depositMethod === "totalPagoBNC" && (
        <FormTotalPagoBNC
          form={formTotalPagoBNC}
          handleChange={handleChangeTotalPagoBNC}
          handleClose={handleExit}
          handleSubmit={submitTotalPagoBNC}
          loading={loading}
        />
      )}

      {depositMethod === "MiBanco" && (
        <FormMiBanco
          form={formMiBanco}
          handleClose={handleExit}
          loading={loading}
        />
      )}
      {depositMethod === "PFqrbisa" && (
        <FormPFqrbisa
          form={formPFqrbisa}
          handleChange={handleChangePFqrbisa}
          handleClose={handleExit}
          handleSubmit={submitPFqrbisa}
          auto={auto}
          loading={loading}
        />
      )}
      {depositMethod === "PFqrMercantil" && (
        <FormPFqrMercantil
          form={formPFqrMercantil}
          handleChange={handleChangePFqrMercantil}
          handleClose={handleExit}
          handleSubmit={submitPFqrMercantil}
          auto={auto}
          loading={loading}
        />
      )}
      {depositMethod === "AlpsEfectivoChile" && (
        <FormAlpsEfectivoChile
          form={formAlpsEfectivoChile}
          handleChange={handleChangeAlpsEfectivoChile}
          handleClose={handleExit}
          handleSubmit={submitAlpsEfectivoChile}
          auto={auto}
          loading={loading}
        />
      )}
      {depositMethod === "AlpsTarjetaChile" && (
        <FormAlpsTarjetaChile
          form={formAlpsTarjetaChile}
          handleChange={handleChangeAlpsTarjetaChile}
          handleClose={handleExit}
          handleSubmit={submitAlpsTarjetaChile}
          auto={auto}
          loading={loading}
        />
      )}
      {depositMethod === "AlpsTransfChile" && (
        <FormAlpsTransfChile
          form={formAlpsTransfChile}
          handleChange={handleChangeAlpsTransfChile}
          handleClose={handleExit}
          handleSubmit={submitAlpsTransfChile}
          auto={auto}
          loading={loading}
        />
      )}
      {depositMethod === "oxxo" && (
        <FormOxxo
          form={formOxxo}
          handleChange={handleChangeOxxo}
          handleClose={handleExit}
          handleSubmit={submitOxxo}
          auto={auto}
          loading={loading}
        />
      )}
      {depositMethod === "astropayCH" && (
        <FormAstroPay
          form={formAstroPay}
          handleChange={handleChangeAstroPay}
          handleClose={handleExit}
          handleSubmit={submitAstroPay}
          loading={loading}
        />
      )}
      {depositMethod === "astropayARG" && (
        <FormAstroPay
          form={formAstroPay}
          handleChange={handleChangeAstroPay}
          handleClose={handleExit}
          handleSubmit={submitAstroPay}
          loading={loading}
        />
      )}
      {depositMethod === "astropayCO" && (
        <FormAstroPay
          form={formAstroPay}
          handleChange={handleChangeAstroPay}
          handleClose={handleExit}
          handleSubmit={submitAstroPay}
          loading={loading}
        />
      )}
      {depositMethod === "monnetGtqCash" && (
        <FormMonnetGTQCash
          form={formMonnetGTQCash}
          handleChange={handleChangeMonnetGTQCash}
          handleClose={handleExit}
          handleSubmit={submitMonnetGTQCash}
          loading={loading}
        />
      )}
      {depositMethod === "monnetGtqTransf" && (
        <FormMonnetGTQTransf
          form={formMonnetGTQTransf}
          handleChange={handleChangeMonnetGTQTransf}
          handleClose={handleExit}
          handleSubmit={submitMonnetGTQTransf}
          loading={loading}
        />
      )}
      {depositMethod === "betterbroTransPYG" && (
        <FormTransPYG
          form={formTransPYG}
          handleChange={handleChangeTransPYG}
          handleClose={handleExit}
          handleSubmit={submitTransPYG}
          loading={loading}
        />
      )}
      {depositMethod === "bdv" && (
        <FormBDV
          form={formBDV}
          handleClose={handleExit}
          loading={loading}
        />
      )}
      {depositMethod === "monnetTarjetaEcu" && (
        <FormMonnetTarjetaEcu
          form={formMonnetTarjetaEcu}
          handleChange={handleChangeMonnetTarjetaEcu}
          handleClose={handleExit}
          handleSubmit={submitMonnetTarjetaEcu}
          loading={loading}
        />
      )}
      {depositMethod === "monnetBancosCH" && (
        <FormMonnetBancosCH
          form={formMonnetBancosCH}
          handleChange={handleChangeMonnetBancosCH}
          handleClose={handleExit}
          handleSubmit={submitMonnetBancosCH}
          loading={loading}
        />
      )}
    </MainViewContainer>
  );
};

export default MainView;
